import React, {Component}   from 'react';
import {Panel}              from 'react-bootstrap'
import CrudComponent        from './../zynappse-crud'
import var1                 from '../schema/Screen.json'
import                           './style.less';

import {connect}            from 'react-redux';
import {bindActionCreators} from 'redux';

import saveTrail            from '../../utils/saveTrail';

class Screen extends Component {
	render() {
		let {access} = this.props.accessjson;

		let crudProps = {
			schema: var1,
			access: access,
			saveTrail: saveTrail
		};

		return (
			<Panel>
				<Panel.Heading style={{
					backgroundColor: '#D1282F',
					color: 'white'
				}}>
					<h4>{var1.classNameLabel.toUpperCase()}</h4>
				</Panel.Heading>
				<Panel.Body>
					<CrudComponent {...crudProps} />
				</Panel.Body>
			</Panel>
		);
	}
}

function mapStateToProps(state) {
	var {accessjson} = state;

	const props = {
		accessjson
	};
	return props;
}

export default connect(mapStateToProps)(Screen);



// WEBPACK FOOTER //
// ./components/Screen/index.js